import React, { useContext } from 'react';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import CompGroupContext from 'context/CompGroupContext';
import { getSelectionCellOptions } from 'pages/ValuationsAllocation/util/getSelectionCellOptions';

type MultipleTypeSelectProps = {
  performanceCellOptions: any;
  shouldIgnorePercentiles: boolean;
  shouldIgnoreSpecified: boolean;
  [key: string]: any;
};

const MultipleTypeSelect = ({ shouldIgnorePercentiles, shouldIgnoreSpecified, ...props }: MultipleTypeSelectProps) => {
  const { cellOptions } = useContext(CompGroupContext);
  const cellOptionsData = cellOptions || props.performanceCellOptions;

  const options = getSelectionCellOptions({
    specificApproach: cellOptionsData,
    shouldIgnorePercentiles,
    shouldIgnoreSpecified,
  });

  // @ts-expect-error: GridSelect is not typed
  return <GridSelect useHandleChange={false} options={options} menuPlacement="top" {...props} enumerated={true} />;
};

export default MultipleTypeSelect;
